import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Avatar, IconButton, Typography } from '@mui/material';

import { Loader } from '@/components/feedback/Loader';
import { initials, useCurrentUser } from '@/features/account';

import { AccountMenu } from './AccountMenu';
import { useAccountMenu } from './useAccountMenu';

export const AccountBlock = () => {
  const user = useCurrentUser();
  const menu = useAccountMenu();

  // The profile is a network read, so the block has a real loading state rather
  // than an avatar with empty initials and two blank lines. Height matches the
  // loaded block so the sidebar foot does not shift when the name arrives.
  if (!user.isLoaded) {
    return (
      <div className="mt-4 flex min-h-15 items-center gap-3 border-t border-divider p-2 pt-4">
        <Loader size="inline" label="Loading your account" />
      </div>
    );
  }

  return (
    <div className="mt-4 flex items-center gap-3 border-t border-divider pt-4">
      {/* The one saturated colour in the chrome, and deliberately so: this is
          identity, not status. A grey circle of initials at the foot of a grey
          rail disappears, and "which account am I in" is the question this
          block exists to answer at a glance. */}
      <Avatar className="size-10 shrink-0 bg-accent text-sm font-semibold text-white">
        {initials(user.fullName)}
      </Avatar>

      {/* min-w-0 lets a long email truncate instead of widening the sidebar. */}
      <div className="min-w-0 flex-1">
        <Typography variant="body2" className="truncate text-sm leading-tight font-semibold">
          {user.fullName}
        </Typography>
        <Typography variant="caption" color="text.secondary" className="block truncate text-xs">
          {user.email}
        </Typography>
      </div>

      <IconButton
        aria-label={`Account options for ${user.fullName}`}
        {...menu.triggerProps}
        onClick={menu.open}
        className="shrink-0"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <AccountMenu
        anchor={menu.anchor}
        id={menu.id}
        onClose={menu.close}
        placement="sidebar-footer"
      />
    </div>
  );
};
